import React, { Component } from 'react';
import { Modal, DatePicker, Row, Button, message, Alert } from "antd";
import moment from "moment";
import FileSaver from "file-saver";
import { inject, observer } from "mobx-react";

const { MonthPicker } = DatePicker;

@inject('store')
@observer
class ExportPdf extends Component {

    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            loading: false,
            hotel: {}
        }
    }

    componentDidMount() {
        this.props.store.menu.getHotelInfo().then(hotel => {
            this.setState({ hotel });
        }).catch(err => {
            console.error(err);
        })
    }

    onExportPdf = () => {
        this.setState({
            visible: true
        });
    }

    handleOk = () => {
        this.setState({ loading: true });
        let date = this.state.date;
        fetch(`/mkPdf?year=${moment(date).format('YYYY')}&month=${moment(date).format('MM')}`, { credentials: 'include' }).then(x => x.blob()).then(x => {

            let file = new Blob([x], { type: "application/pdf" });
            FileSaver.saveAs(file, `${this.state.hotel.name || ""}(${moment(date).format('YYYY-MM')}).pdf`);
            this.setState({ loading: false });
            message.info('导出成功！')
        }).catch(err => {
            this.setState({ loading: false });
            message.info('导出失败！')
            console.error(err);
        })

    }

    handleCancel = () => {
        this.setState({ visible: false });
    }
    render() {

        return (
            <div
                style={{ color: "#1890ff", cursor: "pointer", padding: "10px 20px", textAlign: "center" }}

            >
                <Button onClick={this.onExportPdf} type="primary" style={{ width: '100%' }}>一键导出</Button>
                <Modal
                    title="导出PDF"
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    footer={[
                        <Button key="back" onClick={this.handleCancel}>取消</Button>,
                        <Button key="submit" type="primary" loading={this.state.loading} onClick={this.handleOk}>
                            {this.state.loading ? '导出中，请稍候......' : "导出"}
                        </Button>,
                    ]}
                >
                    <Row className="table-month">
                        <span style={{ marginRight: 20 }}>请选择时间：</span>
                        <MonthPicker
                            placeholder="请选择年月"
                            monthCellContentRender={(date, local) => {
                                return moment(date).format('M月')
                            }}
                            defaultValue={moment(this.state.date, 'YYYY-MM')}
                            format="YYYY-MM"
                            onChange={(date, str) => {
                                this.setState({
                                    date: str
                                });
                            }}
                        />
                        <Alert
                            style={{ marginTop: 20 }}
                            message="警告"
                            description="由于导出内容过多，会导致页面卡顿，导出成功会自动生成pdf文件，在生成文件之前，请勿关闭浏览器和当前页面标签。。。"
                            type="error"
                        />
                    </Row>
                </Modal>
            </div>
        );
    }
}

export default ExportPdf;


// WEBPACK FOOTER //
// ./src/components/app/ExportPdf.js